import React, { useState } from 'react';
import styles from './Footer.module.css';

const CopyIcon = () => (
    <svg 
        aria-hidden="true" 
        focusable="false" 
        data-prefix="far" 
        data-icon="copy" 
        className="svg-inline--fa fa-copy" 
        role="img" 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 448 512"
        width="16"
        height="16"
    >
        <path 
            fill="currentColor" 
            d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"
        />
    </svg>
);

const Footer = () => {
    const [copied, setCopied] = useState(false);
    const email = 'vftmfest@gmail.com';

    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText(email);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <p className={styles.description}>
                    Если у вас возникли вопросы, мы всегда готовы помочь
                </p>
                <div className={styles.contacts}>
                    <a href={`mailto:${email}`} className={styles.email}>
                        {email}
                    </a>
                    <button
                        className={`${styles.copyButton} ${copied ? styles.copied : ''}`}
                        onClick={copyEmail}
                        title="Скопировать email"
                    >
                        {copied ? (
                            <span className={styles.checkIcon}>✓</span>
                        ) : (
                            <span className={styles.copyIcon}>
                                <CopyIcon />
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;